export const chartColors = {
  default: {
    primary: "#00D1B2",
    info: "#209CEE",
    danger: "#FF3860",
  },
};

const randomChartData = (n) => {
  const data = [];

  for (let i = 0; i < n; i++) {
    data.push(Math.round(Math.random() * 20));// Máxima nota, un random entre 0 y 20 o 100 para tomar un 100% para determinar en porcentaje
  }
  //console.log(data)
  return data;
};


const datasetObject = (color, points) => {
  return {
    label: 'Promedio : ',
    //fill: false,
    //backgroundColor: chartColors.default[color],
    borderColor: chartColors.default[color],
    //borderWidth: 2,// LRR Es el ancho de la línea que une los puntos
    //borderDash: [],
    //borderDashOffset: 0.0,
    pointBackgroundColor: chartColors.default[color],
    //pointBorderColor: "rgba(255,255,255,0)",
    pointHoverBackgroundColor: chartColors.default[color],
    //pointBorderWidth: 20,// LRR hace el punto más grande
    pointHoverRadius: 4,
    pointHoverBorderWidth: 15,
    pointRadius: 4,
    data: randomChartData(points),
    //tension: 0.5,// LRR quita las líneas que une los puntos
    //cubicInterpolationMode: "default",
  };
};

export const sampleChartData = (points = 9) => {// Points = Cantidad de cursos o puntos en el área
  
  // --> Luego se jalarán los cursos del estudiante ordenado por área educativa para que así los cursos de la mism área estén juntos
  const labels = ['ARIT', 'GEOM', 'FISI', 'LENG', 'QUIM', 'ARTE', 'BIOL', 'SOYA', 'EDFI'];
  //const labels = ['Aritmética', 'Geometría', 'Física', 'Lenguaje', 'Química', 'Arte', 'Biología', 'Sociedad y Ambiente', 'Educación física'];
  // Tomar números para cantidad de cursos
  /*
  const labels = [];

  for (let i = 1; i <= points; i++) {
    labels.push(`0${i}`);
  }
  */

  return {
    //refs,
    labels,
    datasets: [
      //datasetObject("primary", points),
      datasetObject("info", points),
      //datasetObject("danger", points),
    ],
  };
};
